module.exports = __webpack_public_path__ + "static/img/logo58.c401eb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo58.png
// module id = ZaHR
// module chunks = 1